import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "manifold m-checkout-button-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.parentDataWidgetName)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.dynamicComponent), { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}